import { render, staticRenderFns } from "./InitLocation.vue?vue&type=template&id=7054d14c&lang=pug&"
import script from "./InitLocation.vue?vue&type=script&lang=js&"
export * from "./InitLocation.vue?vue&type=script&lang=js&"
import style0 from "./InitLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports